import React,{ Component } from "react";
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import { Row, Col, Table, Card, CardBody, CardHeader, Button} from "reactstrap";
import Proptypes from "prop-types";
import ReactJson from 'react-json-view';
import {getUrlFilterPolicies, getUrlFilterCategories} from "../../../actions/actionFilters"


class ViewUrlFilter extends Component{
    constructor(props){
        super(props);
         this.state = {
            currentFilter: {}
        }
    }
  
    componentDidMount(){
        this.props.getUrlFilterPolicies();
        this.props.getUrlFilterCategories();
    }
      
    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.filters.length > 0){
            let currentFilter = nextProps.filters.find(filters => filters.filter_policy_id === this.props.match.params.id);
            this.setState({currentFilter: currentFilter});
        }
    }

    category_mapping(filter_categories, categories){
        let out = {};
        categories.map(function (category, keyIndex){
            out[category.label] = filter_categories[category.id];
        });
        return out;
    }

    render(){
        const {currentFilter} = this.state;
        const {categories} = this.props;
        let updated_categories = {};
        if (currentFilter.categories && categories.length >0){
            updated_categories = this.category_mapping(currentFilter.categories, categories)
        }
        return (
            <div className="mt-5">
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>View Web Filter Policy</strong>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                        <div>
                                            {currentFilter && updated_categories ?
                                                <Table bordered>
                                                    <tbody>
                                                        <tr><td>Id</td><td>{currentFilter.filter_policy_id}</td></tr>
                                                        <tr><td>Name</td><td>{currentFilter.filter_policy_name}</td></tr>
                                                        <tr><td>Description</td><td>{currentFilter.filter_policy_descriptions}</td></tr>
                                                        <tr><td>Deny By Default</td><td>{currentFilter.deny_by_default ? "True" : "False"}</td></tr>
                                                        <tr><td>Domain Blacklist</td><td className="word-wrap"><ReactJson src={currentFilter.domain_blacklist ? currentFilter.domain_blacklist : []}
                                                                name={false}
                                                                collapsed={false}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td>Domain Whitelist</td><td className="word-wrap"><ReactJson src={currentFilter.domain_whitelist ? currentFilter.domain_whitelist : []}
                                                                name={false}
                                                                collapsed={false}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td>SSL Bypass Domains</td><td className="word-wrap"><ReactJson src={currentFilter.ssl_bypass_domains ? currentFilter.ssl_bypass_domains : []}
                                                                name={false}
                                                                collapsed={false}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td>SSL Bypass IPs</td><td className="word-wrap"><ReactJson src={currentFilter.ssl_bypass_ips ? currentFilter.ssl_bypass_ips : []}
                                                                name={false}
                                                                collapsed={false}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td>Enable Safe Search</td><td>{currentFilter.enable_safe_search ? "True" : "False"}</td></tr>
                                                        <tr><td>Safe Search Patterns</td><td className="word-wrap"><ReactJson src={currentFilter.safe_search_patterns ? currentFilter.safe_search_patterns : []}
                                                                name={false}
                                                                collapsed={false}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td>Enable Categorization</td><td>{currentFilter.enable_categorization ? "True" : "False"}</td></tr>
                                                        { currentFilter.enable_categorization ?
                                                            <React.Fragment>
                                                                <tr><td>Categories</td><td className="word-wrap"><ReactJson src={updated_categories}
                                                                        name={false}
                                                                        collapsed={false}
                                                                        sortKeys={true}
                                                                        collapseStringsAfterLength={40}
                                                                        enableClipboard={false}
                                                                        displayDataTypes={false}
                                                                /></td></tr>
                                                            </React.Fragment> : ""
                                                        }
                                                    </tbody>
                                                </Table> :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>   
                    </Col>
                </Row>
            </div>
        );}
}

ViewUrlFilter.propTypes = {
    filters: Proptypes.array,
    match: Proptypes.object,
};

export default connect(state => 
    ({
        filters: state.filter.filters || [],
        categories: state.filter.categories || [],
    }),
dispatch => 
    ({  
        getUrlFilterPolicies: () => dispatch(getUrlFilterPolicies()),
        getUrlFilterCategories: () => dispatch(getUrlFilterCategories())
    }))(ViewUrlFilter);


// WEBPACK FOOTER //
// ./src/views/UrlFilter/ViewUrlFilter/ViewUrlFilter.js